import React from "react";
import { Box, useBreakpointValue } from "@chakra-ui/react";
import { DrawingTool as DrawingToolType } from "duck";
import styles from "./DrawingTool.module.css";

type DrawingToolProps = Pick<
  DrawingToolType,
  "canvasRef" | "startDrawing" | "draw" | "stopDrawing" | "toolsConfig"
>;

const DrawingTool: React.FC<DrawingToolProps> = props => {
  const {
    canvasRef,
    startDrawing,
    draw,
    stopDrawing,
    toolsConfig: { mode }
  } = props;
  const isVisible = useBreakpointValue({ base: false, xl: true });

  return (
    <Box
      cursor={mode === "disabled" || !isVisible ? "default" : "none"}
      zIndex={2}
      position="absolute"
      left={0}
      w="100%"
      h="100%"
    >
      <canvas
        ref={canvasRef}
        className={styles.canvas}
        onMouseDown={startDrawing}
        onTouchStart={startDrawing}
        onMouseMove={draw}
        onTouchMoveCapture={draw}
        onMouseUp={stopDrawing}
        onTouchEnd={stopDrawing}
        onMouseLeave={stopDrawing}
      />
    </Box>
  );
};

export default DrawingTool;
